<template>
    <div >
        <v-layout row>
            <v-flex v-if="showCutScheme!=undefined" class="right-cut-scheme" xs2>
                <div v-if="showCutScheme" :style="rightCutCSS">
                    <div v-for="(item, index) in cuttingScheme.sawCuts.pat2"
                        :style="item.css"
                        :key="index"
                    >
                        <span
                            :style="index%2 == 0 ? {'right': 0} : {'left': 0}"
                        >{{item.value.toFixed(1)}}</span>
                    </div>
                </div>
            </v-flex>
            <v-flex xs12 class="main-pattern-container">
                <div
                class="pattern"
                :class="{'rotated': rotatePattern, 'solid-bg': patternSolidBG}"
                :style="css"
                >
                    <div class="circle">
                        <div class="log" :style="logCSS"/>
                        <div class="log-top" :style="logTopCSS"/>
                        <div class="curvature-circle" :style="curvatureCSS"/>
                        <div class="false-core" :style="falseCoreCSS" />
                        <div v-if="showCutScheme" class="cut-circle" :style="cutCircleCSS" />
                        <div v-if="showCross" class="cross" :style="crossCSS">
                            <div class="top-left"></div>
                            <div class="top-right"></div>
                            <div class="bottom-left"></div>
                            <div class="bottom-right"></div>
                        </div>

                        <pattern-vue-node
                            :node="nodes"
                            :showNominal="objHasProperty(nodes, 'meta') ? nodes.meta.showNominal : true"
                            :style="boardsCSS"
                        />
                    </div>
                    <div class="diameter" v-if="showDiameter">&Oslash; {{ diameter }}</div>
                </div>
            </v-flex>

        </v-layout>
        <v-layout row v-if="showCutScheme!=undefined">
            <v-flex class="bottom-cut-scheme" xs12>
                <div v-if="showCutScheme" :style="bottomCutCSS">
                    <div v-for="(item, index) in cuttingScheme.sawCuts.pat1"
                        :style="item.css"
                        :key="index"
                    >
                        <span
                            :style="index%2 == 0 ? {'bottom': 0} : {'top': 0}"
                        >{{item.value.toFixed(1)}}</span>
                    </div>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import PatternVueNode from "@/components/patterns/PatternVueNode";

    export default {
        name: "PatternVue",

        props: [
            "pattern",
            "sizeNominal",
            "falseCore",
            "isDraggable",
            "showDiameter",
            "showCutScheme",
            "showCross",
            "logDTop",
            "logDBottom",
            "curvatureHeight",
            "sideSize",
            "ellipseRatio",
            "rotate",
            "symmetric",
            "cross",
            "rotatePattern",
            "patternSolidBG"
        ],

        components: { PatternVueNode },

        data () {
            return {
                boardsCSS:    {},
                css:          {},
                crossCSS:     {},
                curvatureCSS: {},
                logCSS:       {},
                logTopCSS:    {},
                falseCoreCSS: {},
                bottomCutCSS: {},
                rightCutCSS:  {},
                cutCircleCSS: {},
                defaultKerf:  5,
                cutLineSize:  25,
                diameter:     0,
                nodes:        {},
                patternData:  {},
                showNominal:  true,

                cuttingSchemeStr: ["", "", "", ""],
                cuttingScheme: {
                    nominalSize: {
                        pat1:  [],
                        pat2:  []
                    },
                    sawSize: {
                        pat1:  [],
                        pat2:  []
                    },
                    sawCuts: {
                        pat1:  [],
                        pat2:  []
                    }
                },
                kerfs: {
                    order0: 5,
                    order1: 5,
                    order2: 5
                },

            }
        },

        watch: {
            falseCore: function (val) {
                //let elm = this.$el;

                let pw = this.sideSize ? this.sideSize-this.cutLineSize : 350;
                //let ph = this.sideSize ? this.sideSize-this.cutLineSize : 350;

                let falseCore = val ? val : 0;
                let fontSize  = this.diameter ? pw / this.diameter : 1;

                falseCore = (falseCore < 0 || falseCore > 50)
                    ? falseCore = 0
                    : falseCore;

                this.falseCoreCSS = {
                    display:  !falseCore ? "none" : "block",
                    position: "absolute",
                    width:    this.diameter * falseCore / 100 + "em",
                    height:   this.diameter * falseCore / 100 + "em",
                    fontSize: fontSize + "px"
                }
            },
            /*
            ellipseRatio: function () {
                this.updatePattern(this.pattern);
            },
*/
            rotate: function () {
                this.updatePattern(this.patternData);
            },

            pattern: {
                handler: function (val) {
                    this.cutLineSize = this.showCutScheme == undefined ? 0 : this.cutLineSize;
                    this.updatePattern(val);
                    this.calcDistanceBetweenKerf(val);
                    this.calculateCuts();
                },
                deep: true
            },

            sizeNominal (val) {
                this.showNominal = val == "1";

                let patternData = { ...this.patternData };

                this.prepareMeta(patternData, this.defaultKerf);
                this.updatePattern(patternData);
            }
        },

        mounted () {
            this.updatePattern(this.pattern);
        },

        methods: {
            /**
             * Добавление центральной доски
             *
             * @param {object} board   Информация о доске
             * @param {bool}   prepend Добавить доску в начало...
             */
            addCentralBoard (board, prepend = false, inSameContainer = false) {
                this.setDefaults();

                let newPattern = { ...this.patternData };

                if (Object.keys(newPattern).length === 0 && newPattern.constructor === Object) { // Если постав пустой
                    newPattern       = { ...this.DEFAULT_NEW_PATTERN };
                    newPattern.items = [ ...this.DEFAULT_NEW_PATTERN_ITEMS ];
                    newPattern.items[0].items[0].items.push(board);
                } else if (newPattern.items.length == 0) { // Если параметры постава заданы, а досок нет
                    newPattern.items = [ ...this.DEFAULT_NEW_PATTERN_ITEMS ];
                    newPattern.items[0].items[0].items.push(board);
                } else { // Постав не пустой
                    if (!this.hasCentralBoards(newPattern)) {
                        if (newPattern.items.length == 0) {
                            newPattern.items.push({ ...this.DEFAULT_CENTRAL_CONTAINER });
                        } else {
                            newPattern.items.splice(Math.floor(newPattern.items.length / 2 + 1), 0, { ...this.DEFAULT_CENTRAL_CONTAINER });
                        }
                    } else { // есть блок центральных досок
                        newPattern.items.forEach((itemSide) => {
                            if (typeof itemSide.meta !== "undefined" && !itemSide.meta.isBoard) {
                                if (itemSide.order == 0) {
                                    if (prepend) {
                                        itemSide.items.unshift(board);
                                    } else {
                                        itemSide.items.push(board);
                                    }
                                }

                                itemSide.items.forEach((itemCentral) => {
                                    if (typeof itemCentral.meta !== "undefined" && !itemCentral.meta.isBoard && itemCentral.order == 0) {
                                        if (inSameContainer) {
                                            if (prepend) {
                                                if (itemCentral.items[0].meta.isBoard) {
                                                    let bufBoard = itemCentral.items[0];
                                                    itemCentral.items[0] = { ...this.DEFAULT_SPLITTED_CONTAINER };
                                                    itemCentral.items[0].items.push(bufBoard);
                                                    itemCentral.items[0].items.push(board);
                                                } else {
                                                    itemCentral.items[0].items.push(board);
                                                }

                                            } else {
                                                let lastElem = itemCentral.items.length-1;
                                                if (itemCentral.items[lastElem].meta.isBoard) {
                                                    let bufBoard = itemCentral.items[lastElem];
                                                    itemCentral.items[lastElem] = { ...this.DEFAULT_SPLITTED_CONTAINER };
                                                    itemCentral.items[lastElem].items.push(bufBoard);
                                                    itemCentral.items[lastElem].items.push(board);
                                                } else {
                                                    itemCentral.items[lastElem].items.push(board);
                                                }
                                            }
                                        } else {
                                            if (prepend) {
                                                itemCentral.items.unshift(board);
                                            } else {
                                                itemCentral.items.push(board);
                                            }
                                        }
                                    }
                                });
                            }
                        });
                    }
                }

                this.updatePattern(newPattern);
            },

            /**
             * Добавление боковых досок
             *
             * @param {object} board    Информация о доске
             * @param {number} order    Порядок распила. Для центральных досок оно равно нулю. Для первых боковых - 1, для вторых боковых - 2.
             * @param {number} position Позиция боковой доски центрального лафета (верхняя - 1 или нижняя - 2)
             */
            addSideBoards (board, order, position, inSameContainer = false) {
                this.setDefaults();

                let newPattern = { ...this.patternData };

                if (Object.keys(newPattern).length === 0 && newPattern.constructor === Object) { // Если постав пустой
                    newPattern       = { ...this.DEFAULT_NEW_PATTERN };
                    newPattern.items = [ ...this.DEFAULT_NEW_PATTERN_ITEMS ];
                    inSameContainer = false;
                } else if (newPattern.items.length == 0) { // Если параметры постава заданы, а досок нет
                    newPattern.items = [ ...this.DEFAULT_NEW_PATTERN_ITEMS ];
                    inSameContainer = false;
                }

                if (order == 1) { // Наружный контейнер
                    if (this.symmetric) {
                        if (newPattern.items.length == 1) {
                            inSameContainer = false;
                        }

                        if (inSameContainer) {
                            if (newPattern.items[0].meta.isBoard) {
                                let bufBoard = newPattern.items[0];
                                newPattern.items[0] = JSON.parse(JSON.stringify(this.DEFAULT_SPLITTED_SIDE_CONTAINER));
                                newPattern.items[0].items.push(bufBoard);
                                newPattern.items[0].items.unshift(board);
                            } else {
                                newPattern.items[0].items.unshift(board);
                            }

                            let lastElem = newPattern.items.length-1;
                            if (newPattern.items[lastElem].meta.isBoard) {
                                let bufBoard = newPattern.items[lastElem];
                                newPattern.items[lastElem] = JSON.parse(JSON.stringify(this.DEFAULT_SPLITTED_SIDE_CONTAINER));
                                newPattern.items[lastElem].items.push(bufBoard);
                                newPattern.items[lastElem].items.unshift(board);
                            } else {
                                newPattern.items[lastElem].items.unshift(board);
                            }
                        } else {
                            newPattern.items.unshift({ ...board });
                            newPattern.items.push({ ...board });
                        }
                    } else if (position == 1) {
                        if (newPattern.items.length == 0 || (newPattern.items.length > 0 && newPattern.items[0].order == 2)) {
                            inSameContainer = false;
                        }

                        if (inSameContainer) {
                            if (newPattern.items[0].meta.isBoard) {
                                let bufBoard = newPattern.items[0];
                                newPattern.items[0] = JSON.parse(JSON.stringify(this.DEFAULT_SPLITTED_SIDE_CONTAINER));
                                newPattern.items[0].items.push(bufBoard);
                                newPattern.items[0].items.unshift(board);
                            } else {
                                newPattern.items[0].items.unshift(board);
                            }
                        } else {
                            newPattern.items.unshift({ ...board });
                        }
                    } else {
                        if (newPattern.items.length == 0 || (newPattern.items.length > 0 && newPattern.items[newPattern.items.length-1].order == 2)) {
                            inSameContainer = false;
                        }

                        if (inSameContainer) {
                            let lastElem = newPattern.items.length-1;
                            if (newPattern.items[lastElem].meta.isBoard) {
                                let bufBoard = newPattern.items[lastElem];
                                newPattern.items[lastElem] = JSON.parse(JSON.stringify(this.DEFAULT_SPLITTED_SIDE_CONTAINER));
                                newPattern.items[lastElem].items.push(bufBoard);
                                newPattern.items[lastElem].items.unshift(board);
                            } else {
                                newPattern.items[lastElem].items.unshift(board);
                            }
                        } else {
                            newPattern.items.push({ ...board });
                        }
                    }
                } else if (order == 2) { // Внутренний контейнер
                    newPattern.items.forEach((item) => {
                        if (typeof item.meta !== undefined && !item.meta.isBoard && item.order == 2) {
                            if (typeof item.items == undefined) {
                                item.items = [];
                            }

                            if (item.items.length == 1) {
                                inSameContainer = false;
                            }

                            if (this.symmetric) {
                                if (inSameContainer) {
                                    if (item.items[0].meta.isBoard) {
                                        let bufBoard = item.items[0];
                                        item.items[0] = JSON.parse(JSON.stringify(this.DEFAULT_SPLITTED_CONTAINER));
                                        item.items[0].order = 2;
                                        item.items[0].items.push(bufBoard);
                                        item.items[0].items.push(board);
                                    } else {
                                        item.items[0].items.push(board);
                                    }

                                    let lastElem = item.items.length-1;
                                    if (item.items[lastElem].meta.isBoard) {
                                        let bufBoard = item.items[lastElem];
                                        item.items[lastElem] = JSON.parse(JSON.stringify(this.DEFAULT_SPLITTED_CONTAINER));
                                        item.items[lastElem].order = 2;
                                        item.items[lastElem].items.push(bufBoard);
                                        item.items[lastElem].items.push(board);
                                    } else {
                                        item.items[lastElem].items.push(board);
                                    }
                                } else {
                                    item.items.unshift({ ...board });
                                    item.items.push({ ...board });
                                }
                            } else if (position == 1) {
                                if (item.items.length == 0 || (item.items.length > 0 && item.items[0].order == 0)) {
                                    inSameContainer = false;
                                }

                                if (inSameContainer) {
                                    if (item.items[0].meta.isBoard) {
                                        let bufBoard = item.items[0];
                                        item.items[0] = JSON.parse(JSON.stringify(this.DEFAULT_SPLITTED_CONTAINER));
                                        item.items[0].order = 2;
                                        item.items[0].items.push(bufBoard);
                                        item.items[0].items.push(board);
                                    } else {
                                        item.items[0].items.push(board);
                                    }
                                } else {
                                    item.items.unshift({ ...board });
                                }
                            } else {
                                if (item.items.length == 0 || (item.items.length > 0 && item.items[item.items.length-1].order == 0)) {
                                    inSameContainer = false;
                                }

                                if (inSameContainer) {
                                    let lastElem = item.items.length-1;
                                    if (item.items[lastElem].meta.isBoard) {
                                        let bufBoard = item.items[lastElem];
                                        item.items[lastElem] = JSON.parse(JSON.stringify(this.DEFAULT_SPLITTED_CONTAINER));
                                        item.items[lastElem].order = 2;
                                        item.items[lastElem].items.push(bufBoard);
                                        item.items[lastElem].items.push(board);
                                    } else {
                                        item.items[lastElem].items.push(board);
                                    }
                                } else {
                                    item.items.push({ ...board });
                                }
                            }
                        }
                    });
                }

                this.updatePattern(newPattern);
            },

            /**
             * Вычисление диаметра бревна
             *
             * @param {object} item        Элемент
             * @param {number} defaultKerf Ширина пропила по умолчанию
             * @param {number} xCenter     Координата X центра
             * @param {number} yCenter     Координата Y центра
             */
            calculateDiameter (item, defaultKerf, xCenter, yCenter) {
                if (item.meta.isBoard) {
                    item.meta.x = xCenter;
                    item.meta.y = yCenter;

                    let x = Math.abs(item.meta.x) + 0.5 * item.meta.xSize;
                    let y = Math.abs(item.meta.y) + 0.5 * item.meta.ySize;
                    let d = 2 * Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
                    if (d > this.diameter) { this.diameter = Math.round(d); }
                } else {
                    let itemKerf = item.kerf ? item.kerf : defaultKerf;
                    let xOffset  = (item.meta.isVertical)  ? xCenter : -0.5 * item.meta.xSize;
                    let yOffset  = (!item.meta.isVertical) ? yCenter :  0.5 * item.meta.ySize;

                    item.items.forEach((subItem, index) => {
                        if (item.meta.isVertical) {
                            if (index) { yOffset -= itemKerf; }

                            yOffset -= 0.5 * subItem.meta.ySize;

                            this.calculateDiameter(subItem, itemKerf, xOffset, yOffset);

                            yOffset -= 0.5 * subItem.meta.ySize;
                        } else {
                            if (index) { xOffset += itemKerf; }

                            xOffset += 0.5 * subItem.meta.xSize;

                            this.calculateDiameter(subItem, itemKerf, xOffset, yOffset);

                            xOffset += 0.5 * subItem.meta.xSize;
                        }
                    });
                }
            },

            /**
             * Расчёт ширины между пропилами у постава и центрального лафета
             * учитываются номинальные и пильные размеры сечений
             *
             * @param {object} pattern Исходный постав
             *
             */
             calcDistanceBetweenKerf (pattern) {
                let pat1_nom = [];
                let pat2_nom = [];
                let patCen_nom = [];
                let pat1_saw = [];
                let pat2_saw = [];
                let patCen_saw = [];
                let patCenWidth_nom = [];
                let patCenWidth_saw = [];

                let patternOrder1Center = 0;
                let patternOrder2Center = 0;

                if (pattern.order == 1) {
                    this.kerfs.order1 = pattern.kerf ? pattern.kerf : 5;

                    pattern.items.forEach((element, index) => {
                        this.kerfs.order1 = element.kerf ? element.kerf : this.kerfs.order1;
                        if (element.hasOwnProperty("order")) {
                            if (element.order == 1 && element.items.length != 0) {
                                pat1_nom.push(element.items[0].tn);
                                pat1_saw.push(element.items[0].ts.toFixed(1));
                            } else if (element.order == 2 || element.order == 0) {
                                patternOrder1Center = index;
                            }
                        } else {
                            pat1_nom.push(element.tn);
                            pat1_saw.push(element.ts.toFixed(1));
                        }
                    });

                    if (pattern.items[patternOrder1Center] && pattern.items[patternOrder1Center].order == 2) {
                        this.kerfs.order2 = pattern.items[patternOrder1Center].kerf ? pattern.items[patternOrder1Center].kerf : 5;

                        pattern.items[patternOrder1Center].items.forEach((element, index) => {
                            this.kerfs.order2 = element.kerf ? element.kerf : this.kerfs.order2;
                            if (element.hasOwnProperty("order")) {
                                if (element.order == 2 && element.items.length != 0) {
                                    pat2_nom.push(element.items[0].tn);
                                    pat2_saw.push(element.items[0].ts.toFixed(1));
                                } else if (element.order == 0) {
                                    patternOrder2Center = index;
                                }
                            } else {
                                pat2_nom.push(element.tn);
                                pat2_saw.push(element.ts.toFixed(1));
                            }
                        });

                        if (pattern.items[patternOrder1Center].items[patternOrder2Center].order == 0) {
                            patCenWidth_nom.push(0);
                            patCenWidth_saw.push(0);

                            this.kerfs.order0 = pattern.items[patternOrder1Center].items[patternOrder2Center].kerf
                                ? pattern.items[patternOrder1Center].items[patternOrder2Center].kerf
                                : 5;

                            pattern.items[patternOrder1Center].items[patternOrder2Center].items.forEach((element) => {
                                this.kerfs.order0 = element.kerf ? element.kerf : this.kerfs.order0;
                                if (element.hasOwnProperty("order")) {
                                    if (element.items.length != 0) {
                                        patCen_nom.push(element.items[0].tn);
                                        patCen_saw.push(element.items[0].ts.toFixed(1));

                                        if (patCenWidth_nom[0] == 0) {
                                            patCenWidth_nom.splice(0,1);
                                            patCenWidth_saw.splice(0,1);
                                        }

                                        if (patCenWidth_nom.length < element.items.length) {
                                            patCenWidth_nom.splice(0,patCenWidth_nom.length);
                                            patCenWidth_saw.splice(0,patCenWidth_saw.length);
                                        }

                                        element.items.forEach((element, index) => {
                                            if (patCenWidth_nom[index] == undefined) {
                                                patCenWidth_nom.push(element.wn);
                                                patCenWidth_saw.push(element.ws.toFixed(1));
                                            }

                                            if (patCenWidth_nom[index] < element.wn) {
                                                patCenWidth_nom[index] = element.wn;
                                                patCenWidth_saw[index] = element.ws.toFixed(1);
                                            }
                                        });
                                    }
                                } else {
                                    patCen_nom.push(element.tn);
                                    patCen_saw.push(element.ts.toFixed(1));
                                    patCenWidth_nom[0] = element.wn > patCenWidth_nom[0] ? element.wn : patCenWidth_nom[0];
                                    patCenWidth_saw[0] = element.ws > patCenWidth_saw[0] ? element.ws.toFixed(1) : patCenWidth_saw[0];
                                }
                            });
                        }
                    }

                    if (pattern.items[patternOrder1Center] && pattern.items[patternOrder1Center].order == 0) {
                        patCenWidth_nom.push(0);
                        patCenWidth_saw.push(0);

                        this.kerfs.order0 = pattern.items[patternOrder1Center].kerf ? pattern.items[patternOrder1Center].kerf : 5;

                        pattern.items[patternOrder1Center].items.forEach((element) => {
                            this.kerfs.order0 = element.kerf ? element.kerf : this.kerfs.order0;
                            if (element.hasOwnProperty("order")) {
                                if (element.items.length != 0) {
                                    patCen_nom.push(element.items[0].tn);
                                    patCen_saw.push(element.items[0].ts.toFixed(1));

                                    if (patCenWidth_nom[0] == 0) {
                                        patCenWidth_nom.splice(0,1);
                                        patCenWidth_saw.splice(0,1);
                                    }

                                    if (patCenWidth_nom.length < element.items.length) {
                                        patCenWidth_nom.splice(0,patCenWidth_nom.length);
                                        patCenWidth_saw.splice(0,patCenWidth_saw.length);
                                    }

                                    element.items.forEach((element, index) => {
                                        if (patCenWidth_nom[index] == undefined) {
                                            patCenWidth_nom.push(element.wn);
                                            patCenWidth_saw.push(element.ws.toFixed(1));
                                        }

                                        if (patCenWidth_nom[index] < element.wn) {
                                            patCenWidth_nom[index] = element.wn;
                                            patCenWidth_saw[index] = element.ws.toFixed(1);
                                        }
                                    });
                                }
                            } else {
                                patCen_nom.push(element.tn);
                                patCen_saw.push(element.ts.toFixed(1));
                                patCenWidth_nom[0] = element.wn > patCenWidth_nom[0] ? element.wn : patCenWidth_nom[0];
                                patCenWidth_saw[0] = element.ws > patCenWidth_saw[0] ? element.ws.toFixed(1) : patCenWidth_saw[0];
                            }
                        });
                    }
                }

                if (pattern.order == 2) {
                    this.kerfs.order2 = pattern.kerf ? pattern.kerf : 5;

                    pattern.items.forEach((element, index) => {
                        this.kerfs.order2 = element.kerf ? element.kerf : this.kerfs.order2;
                        if (element.hasOwnProperty("order")) {
                            if (element.order == 2 && element.items.length != 0) {
                                pat2_nom.push(element.items[0].tn);
                                pat2_saw.push(element.items[0].ts.toFixed(1));
                            } else if (element.order == 0) {
                                patternOrder2Center = index;
                            }
                        } else {
                            pat2_nom.push(element.tn);
                            pat2_saw.push(element.ts.toFixed(1));
                        }
                    });

                    if (pattern.items[patternOrder2Center] && pattern.items[patternOrder2Center].order == 0) {
                        patCenWidth_nom.push(0);
                        patCenWidth_saw.push(0);

                        this.kerfs.order0 = pattern.items[patternOrder2Center].kerf ? pattern.items[patternOrder2Center].kerf : 5;

                        pattern.items[patternOrder2Center].items.forEach((element) => {
                            this.kerfs.order0 = element.kerf ? element.kerf : this.kerfs.order0;
                            if (element.hasOwnProperty("order")) {
                                if (element.items.length != 0) {
                                    patCen_nom.push(element.items[0].tn);
                                    patCen_saw.push(element.items[0].ts.toFixed(1));

                                    if (patCenWidth_nom[0] == 0) {
                                        patCenWidth_nom.splice(0,1);
                                        patCenWidth_saw.splice(0,1);
                                    }

                                    if (patCenWidth_nom.length < element.items.length) {
                                        patCenWidth_nom.splice(0,patCenWidth_nom.length);
                                        patCenWidth_saw.splice(0,patCenWidth_saw.length);
                                    }

                                    element.items.forEach((element, index) => {
                                        if (patCenWidth_nom[index] == undefined) {
                                            patCenWidth_nom.push(element.wn);
                                            patCenWidth_saw.push(element.ws.toFixed(1));
                                        }

                                        if (patCenWidth_nom[index] < element.wn) {
                                            patCenWidth_nom[index] = element.wn;
                                            patCenWidth_saw[index] = element.ws.toFixed(1);
                                        }
                                    });
                                }
                            } else {
                                patCen_nom.push(element.tn);
                                patCen_saw.push(element.ts.toFixed(1));
                                patCenWidth_nom[0] = element.wn > patCenWidth_nom[0] ? element.wn : patCenWidth_nom[0];
                                patCenWidth_saw[0] = element.ws > patCenWidth_saw[0] ? element.ws.toFixed(1) : patCenWidth_saw[0];
                            }
                        });
                    }
                }

                if (pattern.order == 0) {
                    patCenWidth_nom.push(0);
                    patCenWidth_saw.push(0);

                    this.kerfs.order0 = pattern.kerf ? pattern.kerf : 5;

                    pattern.items.forEach((element) => {
                        this.kerfs.order0 = element.kerf ? element.kerf : this.kerfs.order0;
                        if (element.hasOwnProperty("order")) {
                            if (element.items.length != 0) {
                                patCen_nom.push(element.items[0].tn);
                                patCen_saw.push(element.items[0].ts.toFixed(1));

                                if (patCenWidth_nom[0] == 0) {
                                    patCenWidth_nom.splice(0,1);
                                    patCenWidth_saw.splice(0,1);
                                }

                                if (patCenWidth_nom.length < element.items.length) {
                                    patCenWidth_nom.splice(0,patCenWidth_nom.length);
                                    patCenWidth_saw.splice(0,patCenWidth_saw.length);
                                }

                                element.items.forEach((element, index) => {
                                    if (patCenWidth_nom[index] == undefined) {
                                        patCenWidth_nom.push(element.wn);
                                        patCenWidth_saw.push(element.ws.toFixed(1));
                                    }

                                    if (patCenWidth_nom[index] < element.wn) {
                                        patCenWidth_nom[index] = element.wn;
                                        patCenWidth_saw[index] = element.ws.toFixed(1);
                                    }
                                });
                            }
                        } else {
                            patCen_nom.push(element.tn);
                            patCen_saw.push(element.ts.toFixed(1));
                            patCenWidth_nom[0] = element.wn > patCenWidth_nom[0] ? element.wn : patCenWidth_nom[0];
                            patCenWidth_saw[0] = element.ws > patCenWidth_saw[0] ? element.ws.toFixed(1) : patCenWidth_saw[0];
                        }
                    });
                }

                patternOrder2Center = patternOrder2Center >= pat2_nom.length ? Math.floor(pat2_nom.length/2) : patternOrder2Center;

                patCen_nom.forEach ((element,index) => {
                    pat2_nom.splice(patternOrder2Center + index, 0, element);
                });
                patCen_saw.forEach ((element,index) => {
                    pat2_saw.splice(patternOrder2Center + index, 0, element);
                });
                patCenWidth_nom.forEach ((element,index) => {
                    pat1_nom.splice(patternOrder1Center + index, 0, element);
                });
                patCenWidth_saw.forEach ((element,index) => {
                    pat1_saw.splice(patternOrder1Center + index, 0, element);
                });

                this.cuttingScheme.nominalSize.pat1 = pat1_nom;
                this.cuttingScheme.nominalSize.pat2 = pat2_nom;
                this.cuttingScheme.sawSize.pat1 = pat1_saw;
                this.cuttingScheme.sawSize.pat2 = pat2_saw;

                this.cuttingSchemeStr = [
                    pat1_nom.toString().replaceAll(",","-"),
                    pat2_nom.toString().replaceAll(",","-"),
                    pat1_saw.toString().replaceAll(",","-"),
                    pat2_saw.toString().replaceAll(",","-")
                ];
            },

            /**
             * Вычисление размеров блоков для отображения постава
             *
             * @param {object} item Корневой элемент
             */
            calculateSizes (item) {
                if (item.meta.isBoard) {
                    let d = item.ws ? item.ts / item.ws : 0.5;
                    let fontSize = 0;

                    if (d < 0.2) { fontSize = 0.5  * item.ts; } else
                    if (d < 0.3) { fontSize = 0.4  * item.ts; } else
                    if (d < 0.4) { fontSize = 0.35 * item.ts; } else
                    if (d < 0.5) { fontSize = 0.3  * item.ts; } else
                    if (d < 0.6) { fontSize = 0.3  * item.ts; } else
                    if (d < 0.8) { fontSize = 0.3  * item.ts; } else
                            { fontSize = 0.15 * item.ts; }

                    fontSize = fontSize < 9 ? 9 : fontSize;
                    fontSize = fontSize > 16 ? 16 : fontSize;

                    item.meta.lblStyle = item.vertical ? { fontSize: fontSize + "em", width: item.ts > item.ws ? item.ts*0.1 + "em" : item.ws*0.09 + "em" } : { fontSize: fontSize + "em" }

                    item.meta.style = item.vertical
                        ? { width: item.ts + "em",  height: item.ws + "em", margin: `${item.meta.topOffset + "em"} ${item.meta.rightOffset + "em"} ${item.meta.bottomOffset + "em"} ${item.meta.leftOffset + "em"}` }
                        : { width: item.ws + "em",  height: item.ts + "em", margin: `${item.meta.topOffset + "em"} ${item.meta.rightOffset + "em"} ${item.meta.bottomOffset + "em"} ${item.meta.leftOffset + "em"}` };

                } else {
                    if (item.items) {
                        item.items.forEach((subItem) => {
                            this.calculateSizes(subItem);
                        });
                    }
                }
            },

            calculateCuts () {
                let pw  = this.sideSize ? this.sideSize-this.cutLineSize : 350;
                let fontSize = this.logDTop ? pw / this.logDBottom : 1;
                let ellipseDrawCoef = this.ellipseRatio && this.ellipseRatio !== 0
                    ? this.ellipseRatio / 100
                    : 0.02;

                let calculateCutSize = (boardsList, kerf, pattern) => {
                    let cutsList = [];
                    let tnSum = 0;
                    cutsList.push(0);

                    boardsList.forEach((item, index) => {
                        if (index != boardsList.length-1) {
                            tnSum += parseFloat(item);
                            tnSum += kerf;
                        }
                        else {
                            tnSum += parseFloat(item);
                        }
                    });

                    cutsList.push((this.logDTop-tnSum)/2);

                    boardsList.forEach((item, index) => {
                        if (index != boardsList.length-1) {
                            if (pattern == 1) {
                                cutsList.push(cutsList[cutsList.length-1] + parseFloat(item) + kerf);
                            }
                            else {
                                if (index == 0) {
                                    cutsList.push(cutsList[cutsList.length-1] + parseFloat(item));
                                }
                                else {
                                    cutsList.push(cutsList[cutsList.length-1] + parseFloat(item) + kerf);
                                }
                            }
                        }
                        else {
                            if (pattern == 1) {
                                cutsList.push(cutsList[cutsList.length-1] + parseFloat(item));
                            }
                            else {
                                cutsList.push(cutsList[cutsList.length-1] + parseFloat(item) + kerf);
                            }
                        }
                    });

                    cutsList.push(this.logDTop);

                    return cutsList;

                };

                let cutsList1 = [];
                let cutsList2 = [];
                let labelcutsList1 = [];
                let labelcutsList2 = [];
                if (this.rotatePattern) {
                    cutsList1 = calculateCutSize(this.cuttingScheme.sawSize.pat2, 3, 2);
                    cutsList2 = calculateCutSize(this.cuttingScheme.sawSize.pat1, 3, 1);
                    labelcutsList1 = calculateCutSize(this.cuttingScheme.sawSize.pat2, this.kerfs.order0, 2);
                    labelcutsList2 = calculateCutSize(this.cuttingScheme.sawSize.pat1, this.kerfs.order1, 1);
                }
                else {
                    cutsList1 = calculateCutSize(this.cuttingScheme.sawSize.pat1, 3, 1);
                    cutsList2 = calculateCutSize(this.cuttingScheme.sawSize.pat2, 3, 2);
                    labelcutsList1 = calculateCutSize(this.cuttingScheme.sawSize.pat1, this.kerfs.order1, 1);
                    labelcutsList2 = calculateCutSize(this.cuttingScheme.sawSize.pat2, this.kerfs.order0, 2);
                }

                this.cuttingScheme.sawCuts.pat1 = [];
                for (let i=0; i<cutsList1.length;++i) {
                    this.cuttingScheme.sawCuts.pat1.push({
                        value:  labelcutsList1[i],
                        css:    {
                            width: `${cutsList1[i]}em`,
                            height: `${this.cutLineSize}px`,
                            fontSize: `${fontSize-ellipseDrawCoef}px`,
                            // border: `solid 1px red`,
                            // 'border-top': `none`,
                            // 'border-bottom': `none`,
                            // 'border-left': `none`,
                            position: `absolute`
                        }
                    });
                }

                this.cuttingScheme.sawCuts.pat2 = [];
                //[labelcutsList2[0], labelcutsList2[labelcutsList2.length-1]] = [labelcutsList2[labelcutsList2.length-1], labelcutsList2[0]];
                //labelcutsList2 = labelcutsList2.reverse();
                for (let i=0; i<labelcutsList2.length;++i) {
                    labelcutsList2[i] = this.logDTop - labelcutsList2[i];
                }
                for (let i=0; i<cutsList2.length;++i) {
                    this.cuttingScheme.sawCuts.pat2.push({
                        value:  labelcutsList2[i],
                        css:    {
                            width: `${this.cutLineSize}px`,
                            height: `${cutsList2[i]}em`,
                            fontSize: `${fontSize-ellipseDrawCoef}px`,
                            // border: `solid 1px red`,
                            // 'border-right': `none`,
                            // 'border-top': `none`,
                            // 'border-left': `none`,
                            position: `absolute`
                        }
                    });
                }

                let logHeight = this.ellipseRatio && this.ellipseRatio !== 0
                    ? Number.parseInt(this.logDBottom * (1 + this.ellipseRatio / 100))
                    : this.logDBottom;

                this.bottomCutCSS = {
                    width:  `${this.logDTop}em`,
                    height: `${this.cutLineSize}px`,
                    fontSize: `${fontSize-ellipseDrawCoef}px`,
                    'margin-right': `${logHeight/2 - this.logDTop/2}em`,
                    float: `inline-end`
                };
                this.rightCutCSS = {
                    height:  `${this.logDTop}em`,
                    width: `${this.cutLineSize}px`,
                    fontSize: `${fontSize-ellipseDrawCoef}px`,
                    'margin-top': `${logHeight/2 - this.logDTop/2 +2}em`,
                };
            },

            /**
             * Пронумеровывание досок и пар досок
             *
             * @param {object} startContainer Исходный контейнер
             * @param {number} startIndex     Исходный индекс
             * @param {number} maxLength      Максимальная длина доски
             */
            enumBoards (startContainer, startIndex = 0, maxLength = 0, isSplittedConatiner = false) {
                let component = this;
                let curIndex  = parseInt(startIndex);

                if (startContainer == undefined || startContainer.items == undefined) {
                    /*
                    if (process.env.NODE_ENV == "development") {
                        this.$debug.log(startContainer);
                        if (startContainer !== undefined) {
                            this.$debug.log(startContainer.items);
                        }
                    }
                    */

                    return;
                }

                if (startContainer.order <= 0) { // Центральная доска
                    //let num = 0;
                    startContainer.items.forEach((item) => {
                        if (item.meta.isBoard) {
                            //curIndex++;
                            item.meta.index   = 3000 + curIndex++;
                            item.meta.isShort = item.meta.len !== undefined ? item.meta.len < maxLength : false;
                        } else {
                            curIndex = component.enumBoards(item, curIndex++, maxLength);
                            curIndex++;
                        }
                    });
                } else { // Боковые доски
                    for (let i = 0; i <= Math.floor(startContainer.items.length / 2 + 1); i++) {
                        if (i < startContainer.items.length) {
                            if (startContainer.items[i].meta.isBoard) {
                                /*
                                if (process.env.NODE_ENV == "development") {
                                    this.$debug.log(startContainer.items[i].meta);
                                }
                                */

                                startContainer.items[i].meta.index = (startContainer.items[i].meta.isVertical ? 1000 : 2000) + curIndex++;
                                if (this.symmetric) {
                                    if (isSplittedConatiner) {
                                        curIndex++;
                                    }
                                    startContainer.items[startContainer.items.length - i - 1].meta.index = (startContainer.items[i].meta.isVertical ? 1000 : 2000) + curIndex - 1 ; //++;
                                }
                                startContainer.items[i].meta.isShort = startContainer.items[i].meta.len !== undefined ? startContainer.items[i].len < maxLength : false;
                                startContainer.items[startContainer.items.length - i - 1].meta.isShort = startContainer.items[i].meta.isShort;
                            } else {
                                component.enumBoards(startContainer.items[i], curIndex++, maxLength, startContainer.items[i].order == startContainer.order);
                                if (this.symmetric) {
                                    component.enumBoards(
                                        startContainer.items[startContainer.items.length - i - 1],
                                        curIndex - 1,
                                        maxLength,
                                        startContainer.items[startContainer.items.length - i - 1].order == startContainer.order
                                        );
                                }
                                curIndex++;
                            }
                        }
                    }
                }

                return curIndex;
            },

            /**
             * Возвращает максимальную длину доски
             *
             * @param {object} startContainer Начальный контейнер для расчёта
             *
             * @returns {number}
             */
            getMaxLength (startContainer) {
                let maxLength = 0;

                if (startContainer.items !== undefined) { // контейнер
                    let parent = this;
                    startContainer.items.forEach((board) => {
                        if (board.items !== undefined) { // контейнер
                            let len = parent.getMaxLength(board);
                            if (len > maxLength) {
                                maxLength = len;
                            }
                        } else { // доска
                            if (board.len !== undefined) {
                                if (board.len > maxLength) {
                                    maxLength = board.len;
                                }
                            }
                        }
                    });
                }

                return maxLength;
            },

            /**
             * Возвращает постав
             *
             * @returns {object}
             */
            getPattern () {
                //let expNodes = JSON.parse(JSON.stringify(this.nodes));
                let expNodes = { ...this.nodes };

                expNodes = this.removeMeta(expNodes);

                return expNodes;
            },

            /**
             * Проверка является ли элемент доской
             *
             * @param {object} item Проверяемый элемент
             *
             * @returns {bool}
             */
            isBoard (item) { return !item.items; },

            /**
             * Проверка есть ли в поставе центральные доски
             *
             * @param {object} pattern Постав
             *
             * @returns {bool}
             */
            hasCentralBoards (pattern) {
                let hasBoards = false;

                if (typeof pattern.items !== undefined) {
                    pattern.items.some((itemSide) => {
                        if (typeof itemSide.meta !== undefined && !itemSide.meta.isBoard) {
                            if (itemSide.order == 0) {
                                hasBoards = true;
                                return;
                            }

                            itemSide.items.some((itemCentral) => {
                                if (typeof itemCentral.meta !== undefined && !itemCentral.meta.isBoard && itemCentral.order == 0) {
                                    hasBoards = true;
                                    return;
                                }
                            });
                        }
                    });
                }

                return hasBoards;
            },

            /**
             * Проверка есть ли у объекта свойство
             *
             * @param {object} obj  Проверяемый объект
             * @param {string} prop Название свойства
             *
             * @returns {bool}
             */
            objHasProperty(obj, prop) {
                let proto = obj.__proto__ || obj.constructor.prototype;
                return (prop in obj) &&
                    (!(prop in proto) || proto[prop] !== obj[prop]);
            },

            /**
             * Парсинг формата версии 1
             *
             * @param {object} data Данные в формате версии 1
             *
             * @returns {object}
             */
            parseV1 (data) {
                let out = {};

                if (data.Species     !== undefined) { out.species   = data.Species; }
                if (data.Du          !== undefined) { out.du        = data.Du; }
                if (data.DLimitMin   !== undefined) { out.dlimitmin = data.DLimitMin; }
                if (data.DLimitMax   !== undefined) { out.dlimitmax = data.DLimitMax; }
                if (data.Dmin        !== undefined) { out.dmin      = data.Dmin; }
                if (data.Dmax        !== undefined) { out.dmax      = data.Dmax; }
                if (data.order       !== undefined) { out.order     = data.order; }
                if (data.saw         !== undefined) { out.kerf      = data.saw; }
                if (data.orientation !== undefined) { out.vertical  = data.orientation == "vertical" ? 1 : 0; }
                if (data.fact_height !== undefined) { out.ts        = data.fact_height; }
                if (data.fact_width  !== undefined) { out.ws        = data.fact_width; }
                if (data.height      !== undefined) { out.tn        = data.height; }
                if (data.width       !== undefined) { out.wn        = data.width; }
                if (data.items       !== undefined) { out.items     = this.parseV1(data.items); }

                if (data.length) { // !== undefined) {
                    let result = [];
                    data.forEach((item) => {
                        result.push(this.parseV1(item));
                    });
                    out = result;
                } else {
                    out.v = 2;
                }

                return out;
            },

            /**
             * Подготовка метаданных
             *
             * @param {object} item        Элемент постава
             * @param {number} defaultKerf Ширина пропила по умолчанию
             */
            prepareMeta (item, defaultKerf) {
                item.meta = {};
                item.meta.isBoard     = !item.items;
                item.meta.isVertical  = item.vertical == 1;
                item.meta.showNominal = this.showNominal;

                item.meta.topOffset = 0;
                item.meta.rightOffset = 0;
                item.meta.bottomOffset = 0;
                item.meta.leftOffset = 0;

                if (item.meta.isBoard) {
                    item.meta.xSize     = item.meta.isVertical ? item.ts : item.ws;
                    item.meta.ySize     = item.meta.isVertical ? item.ws : item.ts;
                    item.meta.draggable = this.isDraggable;
                    item.meta.len = item.len !== undefined ? item.len : 0;

                    item.meta.topOffset = defaultKerf / 2;
                    item.meta.rightOffset = defaultKerf / 2;
                    item.meta.bottomOffset = defaultKerf / 2;
                    item.meta.leftOffset = defaultKerf / 2;

                } else {
                    let itemKerf = item.kerf ? item.kerf : defaultKerf;

                    item.meta.xSize = 0;
                    item.meta.ySize = 0;
                    if (item.items) {
                        item.items.forEach((subItem, index) => {
                            if (!subItem.items) {
                                subItem.order = item.order;
                            }
                            this.prepareMeta(subItem, itemKerf);

                            if (item.meta.isVertical) {
                                if (subItem.meta.xSize > item.meta.xSize) {
                                    item.meta.xSize = subItem.meta.xSize;
                                }

                                item.meta.ySize += subItem.meta.ySize;

                                if (index) { item.meta.ySize += itemKerf; }
                            } else {
                                item.meta.xSize += subItem.meta.xSize;

                                if (subItem.meta.ySize > item.meta.ySize) {
                                    item.meta.ySize = subItem.meta.ySize;
                                }

                                if (index) { item.meta.xSize += itemKerf; }
                            }
                        });
                    }
                }

                if (!item.meta.isBoard && item.cylinder == 1) {
                    item.items[0].items[0].items[0].cylinder = 1;
                } else if (!item.meta.isBoard && item.cylinder == 0) {
                    item.items[0].items[0].items[0].cylinder = 0;
                }
            },

            /**
             * Удаление доски или парных досок
             *
             * @param {object} startContainer Исходный контейнер для поиска (null для всего постава)
             * @param {number} boardIndex     Индекс доски (data-index)
             */
            removeBoard (startContainer, boardIndex) {
                let container = startContainer == null ? this.patternData : startContainer;  //{ ...startContainer } : { ...this.patternData };
                let component = this;

                for (let i = container.items.length - 1; i >= 0 ; i--) {
                    if (container.items[i].meta.isBoard && container.items[i].meta.index == boardIndex) {
                        container.items.splice(i, 1);
                    } else if (!container.items[i].meta.isBoard) {
                        component.removeBoard(container.items[i], boardIndex);
                    }
                }

                if (startContainer == null) {
                    this.updatePattern(container);
                }
            },

            removeEmptyContainers (startContainer, order = 1) {
                let container = startContainer == null ? this.patternData : startContainer;

                let nextOrder = -1;
                let nextOrderContainer = 0;

                for (let i=0; i < container.items.length; ++i) {
                    if (container.items[i].order != undefined && container.items[i].order != order) {
                        nextOrder = container.items[i].order;
                        nextOrderContainer = i;
                    }
                    if (container.items[i].items != undefined && container.items[i].items.length == 0) {
                        delete container.items.splice(i,1);
                    }
                }

                if (nextOrder != -1) {
                    this.removeEmptyContainers(container.items[nextOrderContainer], nextOrder);
                } else {
                    this.updatePattern(this.patternData);
                }
            },

            /**
             * Удаление метаданных из элемента и его потомков
             *
             * @param {object} item Корневой элемент
             */
            /*
            removeMeta (item) {
                if (item.meta) { delete item.meta; }

                if (item.items) {
                    item.items.slice().reverse().forEach((subItem) => {
                        this.removeMeta(subItem);
                    });
                }
            },
            */

            /**
             * Удаление метаданных из элемента и его потомков
             *
             * @param {object} object Корневой элемент
             */
            removeMeta (object) {
                const obj = JSON.parse(JSON.stringify(object)); //{ ...object }; //

                if (obj.hasOwnProperty("meta")) {
                    delete obj.meta;
                }

                for (let item in obj) {
                    if (typeof obj[item] === "object") { obj[item] = this.removeMeta(obj[item]); }
                }

                return obj;
            },

            /**
             * Сброс данных
             */
            reset () {
                this.patternData = {};
            },

            /**
             * Установка значений по умолчанию
             */
            setDefaults () {
                this.DEFAULT_CENTRAL_CONTAINER = {
                    order:    0,
                    vertical: 1,
                    meta: {
                        isBoard:     false,
                        isVertical:  false,
                        showNominal: true,
                        xSize:       0,
                        ySize:       0
                    }
                };

                this.DEFAULT_NEW_PATTERN = {
                    dlimitmin: 140,
                    dlimitmax: 220,
                    dmin:      140,
                    dmax:      220,
                    du:        16,
                    kerf:      5,
                    order:     1,
                    species:   "spruce",
                    v:         2,
                    vertical:  0,
                    meta: {
                        isBoard:     false,
                        isVertical:  true,
                        showNominal: true,
                        xSize:       0,
                        ySize:       0
                    },
                    items: []
                };

                this.DEFAULT_NEW_PATTERN_ITEMS = [
                    {
                        order:    2,
                        vertical: 1,
                        meta: {
                            isBoard:     false,
                            isVertical:  true,
                            showNominal: true,
                            xSize:       0,
                            ySize:       0,
                            len:         0
                        },
                        items: [
                            {
                                order:    0,
                                vertical: 1,
                                meta: {
                                    isBoard:     false,
                                    isVertical:  true,
                                    showNominal: true,
                                    xSize:       0,
                                    ySize:       0,
                                    len:         0
                                },
                                items: []
                            }
                        ]
                    }
                ];

                this.DEFAULT_SPLITTED_CONTAINER = {
                    order:    -1,
                    vertical: 0,
                    meta: {
                        isBoard:     false,
                        isVertical:  false,
                        showNominal: true,
                        xSize:       0,
                        ySize:       0
                    },
                    items: []
                };

                this.DEFAULT_SPLITTED_SIDE_CONTAINER = {
                    order:    1,
                    vertical: 1,
                    meta: {
                        isBoard:     false,
                        isVertical:  true,
                        showNominal: true,
                        xSize:       0,
                        ySize:       0
                    },
                    items: []
                };
            },

            /**
             * Обновление постава
             *
             * @param {object} newPattern Информация о новом поставе
             */
            updatePattern (newPattern) {
                //this.$debug.log("updatePattern");
                this.diameter = 0;

                let patternData = newPattern.v !== 2 ? this.parseV1(newPattern) : JSON.parse(JSON.stringify(newPattern));

                patternData.v = 2;
                this.patternData = patternData;

                this.prepareMeta(patternData, this.defaultKerf);

                let maxLength = this.getMaxLength(patternData);

                patternData.meta.maxLength = maxLength;

                this.calculateSizes(patternData);
                this.calculateDiameter(patternData, this.defaultKerf, 0, 0);

                //this.$debug.log("call enum");

                this.enumBoards(patternData, 0, maxLength);

                this.nodes = patternData;

                /* Подготовка CSS для постава */
                //let elm = this.$el;

                let pw  = this.sideSize ? this.sideSize-this.cutLineSize : 350;
                //let ph  = this.sideSize ? this.sideSize-this.cutLineSize : 350;

                let ellipseDrawCoef = this.ellipseRatio && this.ellipseRatio !== 0
                    ? this.ellipseRatio / 100
                    : 0.02;

                this.crossCSS = {
                    width:    `${this.logDBottom}em`,
                    height:   `${this.logDBottom}em`,
                    position: "absolute",
                    //display:  !cross ? "none" : "block"
                }

                if (this.logDBottom !== undefined && this.logDTop !== undefined) {
                    // Отображение постава с учетом всех параметров
                    let fontSize = this.diameter ? pw / this.logDBottom : 1;

                    this.boardsCSS = {
                        fontSize: `${fontSize - ellipseDrawCoef}px`
                    }

                    this.css = {
                        width:    `${this.logDBottom}em`,
                        height:   `${this.logDBottom}em`,
                        fontSize: `${fontSize}px`
                    }

                    let logWidth = this.ellipseRatio && this.ellipseRatio !== 0
                        ? Number.parseInt(this.logDBottom * (1 - this.ellipseRatio / 100))
                        : this.logDBottom;

                    let logHeight = this.ellipseRatio && this.ellipseRatio !== 0
                        ? Number.parseInt(this.logDBottom * (1 + this.ellipseRatio / 100))
                        : this.logDBottom;

                    this.logCSS = {
                        width:    `${logWidth}em`,
                        height:   `${logHeight}em`,
                        rotate:   `${this.rotate}deg`,
                        fontSize: `${fontSize - ellipseDrawCoef}px`,
                        backgroundSize: `${logWidth}em ${logHeight}em`
                    };

                    let falseCore = this.falseCore ? this.falseCore : 0;

                    falseCore = falseCore < 0 || falseCore > 50
                        ? 0
                        : falseCore;

                    let falseCoreWidth = this.ellipseRatio && this.ellipseRatio !== 0
                        ? Number.parseInt(this.diameter * (1 - this.ellipseRatio / 100) * falseCore / 100)
                        : this.diameter * falseCore / 100;

                    this.falseCoreCSS = {
                        display:  !falseCore ? "none" : "block",
                        position: "absolute",
                        width:    `${falseCoreWidth}em`,
                        height:   `${this.diameter * falseCore / 100}em`,
                        fontSize: `${fontSize}px`
                    };

                    let topWidth = this.ellipseRatio && this.ellipseRatio !== 0
                        ? parseInt(this.logDTop * 0.99 * (1 - this.ellipseRatio / 100))
                        : this.logDTop * 0.99;

                    let topHeight = this.ellipseRatio && this.ellipseRatio !== 0
                        ? Number.parseInt(this.logDTop * 0.99 * (1 + this.ellipseRatio / 100))
                        : this.logDTop * 0.99;

                    this.logTopCSS = {
                        width:    `${topWidth}em`,
                        height:   `${topHeight * 0.99}em`,
                        rotate:   `${this.rotate}deg`,
                        fontSize: `${fontSize - ellipseDrawCoef}px`,
                        backgroundSize: `${topWidth}em ${topHeight}em`
                    };

                    let middleD = parseInt(this.logDTop) + (parseInt(this.logDBottom) - parseInt(this.logDTop)) / 2;
                    let middleWidth = this.ellipseRatio !== undefined && this.ellipseRatio !== 0
                        ? parseInt(middleD * 0.99 * (1 - parseInt(this.ellipseRatio) / 100))
                        : middleD * 0.99;

                    middleD = this.ellipseRatio && this.ellipseRatio !== 0
                        ? Number.parseInt(middleD * (1 + this.ellipseRatio / 100))
                        : middleD;

                    this.curvatureCSS = {
                        width:    `${middleWidth}em`,
                        height:   `${middleD * 0.99}em`,
                        rotate:   `${this.rotate}deg`,
                        fontSize: `${fontSize - ellipseDrawCoef}px`,
                        backgroundSize: `${middleWidth}em ${middleD * 0.99}em`,
                        margin:   `${-this.curvatureHeight}em 0 0 0`
                    };

                    this.cutCircleCSS = {
                        width:    `${this.diameter}em`,
                        height:   `${this.diameter}em`,
                        fontSize: `${fontSize - ellipseDrawCoef}px`,
                    };
                } else {
                    // Упрощенное отображение постава (без вершины, кривизны)
                    // используется на вкладках: библиотека поставов, оптимальный диаметр
                    let fontSize = this.diameter ? (pw / this.diameter) : 1;

                    this.boardsCSS = {
                        fontSize: `${fontSize}px`
                    };

                    this.css = {
                        width:    `${this.diameter}em`,
                        height:   `${this.diameter}em`,
                        fontSize: `${fontSize}px`
                    };
                    /*
                    let logWidth = this.ellipseRatio && this.ellipseRatio !== 0
                        ? Number.parseInt(this.diameter * (1 - this.ellipseRatio / 100))
                        : this.diameter - 3;
                    */
                    this.logCSS = {
                        width:    `${this.diameter}em`,
                        height:   `${this.diameter}em`,
                        rotate:   `${this.rotate}deg`,
                        fontSize: `${fontSize}px`,
                        backgroundSize: `${this.diameter}em ${this.diameter}em`
                    };

                    let falseCore = this.falseCore ? this.falseCore : 0;

                    falseCore = falseCore < 0 || falseCore > 50
                        ? 0
                        : falseCore;

                    this.falseCoreCSS = {
                        display:  !falseCore ? "none" : "block",
                        position: "absolute",
                        width:    `${this.diameter * falseCore / 100}em`,
                        height:   `${this.diameter * falseCore / 100}em`,
                        fontSize: `${fontSize}px`
                    }

                    this.logTopCSS    = { display: "none" }
                    this.curvatureCSS = { display: "none" }
                }
                /* /Подготовка CSS для постава */
            }
        }
    }
</script>

<style lang="sass">
    $central-board-background: #ffda3a
    $board-background: #ffec9c
    $short-board-background: #fff6d3
    $zero-board-background: #d1d1d1
    $hover-box-shadow: 0 1px 2px rgba(0,0,0,0.5)
    $hover-background: #ff7

    .bottom-cut-scheme
        width: 100%
        height: 30px
        max-height: 30px
        span
            font-size: 10px
            display: inline-block
            text-align: center
            position: absolute
            right: 0
            height: 12px !important
            border-right: 1px solid red
            padding-right: 1px

    .right-cut-scheme
        height: 100%
        width: 30px
        max-width: 30px
        span
            font-size: 10px
            text-align: center
            transform: rotate(-90deg)
            transform-origin: center
            position: absolute
            bottom: -2px
            width: 12px !important
            border-left: 1px solid red
            padding-left: 1px

    .no-text-info
        .label
            display: none

    .main-pattern-container
        display: flex
        justify-content: center

    .pattern
        position: relative
        box-sizing: border-box
        overflow: hidden
        float: left
        display: flex
        flex-direction: row
        justify-content: center
        align-items: center
        flex-wrap: nowrap

        -webkit-touch-callout: none
        -webkit-user-select: none
        -khtml-user-select: none
        -moz-user-select: none
        -ms-user-select: none
        user-select: none

        span,
        .label
            color: #000

        .cross
            width: 100%
            height: 100%
            div
                width: 50%
                height: 50%
                display: inline-block
            .top-right, .bottom-left
                border: dashed 1px rgba(0, 0, 0, .6)
            .top-left, .top-right
                border-top: none
            .top-left
                border-left: none
            .top-right
                border-right: none
            .bottom-left, .bottom-right
                border-bottom: none
            .bottom-left
                border-left: none
            .bottom-right
                border-right: none

        .horizontal.container
            display: flex
            flex-direction: row
            justify-content: center
            align-items: center
            flex-wrap: nowrap
            margin: 0
            padding: 0

        .curvature-circle
            border-radius: 50%
            background: none
            opacity: 0.6
            border: 2px dashed black
            position: absolute

        .cut-circle
            border-radius: 50%
            background: none
            opacity: 0.6
            border: 2px solid red
            position: absolute

        .circle
            display: flex
            flex-direction: row
            justify-content: center
            align-items: center
            flex-wrap: nowrap
            >
                .log
                    position: absolute
                    border: 1px solid  #dd9911
                    border-radius: 50%
                    background:  #e1ca8f
                    background-image: url("../../assets/tree_rings.webp")
                    background-size: cover
                    display: flex
                    flex-direction: row
                    justify-content: center
                    align-items: center
                    flex-wrap: nowrap
                    font-size: 1px
                    box-shadow: 1px 1px 3px rgba(0,0,0,0.8)
                .horizontal.container,
                .vertical.container
                    padding: 24px

        .vertical.container
            display: flex
            flex-direction: column
            justify-content: center
            align-items: center
            flex-wrap: nowrap
            margin: 0
            padding: 0

        .container.central
            .board
                background: $central-board-background
                &:hover
                    background: $hover-background
                    box-shadow: $hover-box-shadow

        .board
            box-sizing: border-box
            background: $board-background
            border: 1px solid #bb7700
            display: flex
            justify-content: center
            align-items: center
            cursor: pointer
            opacity: .65
            &:hover
                background: $hover-background
                box-shadow: $hover-box-shadow

        .board.short,
        .horizontal.board.short
            background-color: $short-board-background
            &.short:hover
                background: $hover-background
                box-shadow: $hover-box-shadow

        .board.zero,
        .horizontal.board.zero
            background-color: $zero-board-background

        .node.vertical.container
            flex: 0 0 !important

        .vertical.board
            span
                //white-space: nowrap
                text-align: center
                position: absolute
                transform: rotate(-90deg)

        .log-top
            border-radius: 50%
            background: none
            opacity: 0.6
            border: 2px solid black
            position: absolute

        .false-core
            border: 1px solid #880202
            border-radius: 50%
            background: dashed #880202
            background: repeating-linear-gradient(-45deg, #880202, #880202 5px, transparent 5px, transparent 10px)
            background-size: cover
            display: flex
            flex-direction: row
            justify-content: center
            align-items: center
            flex-wrap: nowrap
            font-size: 1px

        .diameter
            position: absolute
            right: 8px
            bottom: 4px
            font-size: 14px

        .round
            border-radius: 100%

        &.rotated
            .circle
                -webkit-transform: rotate(270deg)
                -moz-transform: rotate(270deg)
                -o-transform: rotate(270deg)
                -ms-transform: rotate(270deg)
                transform: rotate(270deg)

                .node.vertical.board > .label
                    -webkit-transform: rotate(90deg)
                    -moz-transform: rotate(90deg)
                    -o-transform: rotate(90deg)
                    -ms-transform: rotate(90deg)
                    transform: rotate(90deg)
        &.solid-bg
            .circle
                .log
                    background-image: none !important
                    opacity: 0.7
</style>
